import { useTechDocsReaderPage } from '@backstage/plugin-techdocs-react';
import { makeStyles } from '@material-ui/core';
import { DismissableBanner } from '@backstage/core-components';

const useStyles = makeStyles(() => ({
  wrapper: {
    width: '100%',
  },
}));

// Add the 'name' property of the TechDocs entity that should be included for showing the banner to this array
const entityNamesWithBanner = ['omnia'];

export const DisclaimerBanner = () => {
  const { entityRef } = useTechDocsReaderPage();
  const classes = useStyles();

  // Check if entity is in include list (always evaluated with current entityRef)
  const shouldShowBanner = entityNamesWithBanner.includes(entityRef.name);

  // Dismissed state is handled by the backstage component itself
  // State is stored in localStorage under key: "/notifications/dismissedBanners" with id passed to the component (i.e. 'techdocs-disclaimer')
  if (!shouldShowBanner) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <DismissableBanner
        id="techdocs-disclaimer"
        variant="info"
        message="Note: This page may look different than the original site. However, the content is the same."
      />
    </div>
  );
};
